import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const StyleMessageItemWrapper = styled.div<{ isOwner?: boolean }>`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 14px;
  ${(props: any) =>
    props.isOwner &&
    css`
      justify-content: flex-end;
    `}
  @media (max-width: 768px) {
    transform: translateX(-10px);
  }
`

export const MessageContainer = styled.div`
  position: relative;
  display: flex;
  width: fit-content;
  max-width: 60%;
  flex-direction: column;
`

export const Message = styled.p<{ isOwner?: boolean }>`
  padding: 12px 52px 12px 12px;
  border-radius: 12px;
  background-color: ${({ theme }: any) => theme.colors.lightBlue50};
  font-size: 14px;
  margin-bottom: 8px;
  position: relative;
  ${({ isOwner, theme }: any) =>
    isOwner &&
    css`
      background-color: ${theme.colors.primary};
      color: ${theme.colors.white};
    `}

  @media(max-width:768px) {
    font-size: 10px;
  }
`

export const Name = styled.p`
  position: absolute;
  left: 0;
  top: -25px;
  color: ${(props: any) => props.theme.colors.greytext1};
  font-size: 14px;
  @media (max-width: 768px) {
    font-size: 10px;
    top: -14px;
  }
`

export const Time = styled.p`
  position: absolute;
  right: 14px;
  bottom: -10px;
  font-size: 12px;
  color: ${({ theme }: any) => theme.colors.secondaryText};
  white-space: nowrap;
  @media (max-width: 768px) {
    font-size: 8px;
    bottom: -4px;
  }
`

export const TextMessage = styled.span`
  display: block;
  white-space: pre-wrap;
`

export const ImageGrid = styled.div<{ count: number }>`
  display: grid;
  gap: 8px;
  grid-template-columns: ${({ count }) =>
    count === 1 ? '1fr' : 'repeat(2, 1fr)'};
`

export const ChatImage = styled.img`
  width: 150px;
  height: 150px;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 10px;
`
